import { useQuery } from "@tanstack/react-query"
import { getCompanyData, getLogo } from "../../api/apiCalls"

/** Firmenfarbe und Logo aus den öffentlichen Endpunkten (vor und nach der Anmeldung, gleiche Query-Keys). */
export const useCompanyBranding = () => {
    const { data: companyData, isLoading } = useQuery({
        queryKey: ["COMPANY_DATA"],
        queryFn: getCompanyData,
        retry: false,
        staleTime: Infinity,
    })
    const { data: logo } = useQuery({
        queryKey: ["COMPANY_DATA_LOGO"],
        queryFn: getLogo,
        enabled: !!companyData?.logo?.s3Key,
        retry: false,
        staleTime: Infinity,
    })
    return { companyData, logo, isLoading }
}
